export default "__VITE_ASSET__DPNhHE3g__"